<template>
  <div class="card h-100">
    <div class="card-header bg-success text-white">
      <h5 class="mb-0">
        <i class="fas fa-chart-line me-2"></i>Répartition par niveau d'expérience
      </h5>
    </div>
    <div class="card-body">
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-success" role="status">
          <span class="visually-hidden">Chargement...</span>
        </div>
      </div>
      <ChartJs 
        v-else 
        type="doughnut" 
        :data="chartData" 
        :options="chartOptions" 
        class="h-100"
      />
    </div>
  </div>
</template>

<script>

export default {
  name: 'ExperienceDistributionChart',
  data() {
    return {
      loading: true,
      chartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'right',
            labels: {
              boxWidth: 15,
              padding: 15
            }
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                const label = context.label || '';
                const value = context.raw || 0;
                const total = context.chart.getDatasetMeta(0).total;
                const percentage = Math.round((value / total) * 100);
                return `${label}: ${value} (${percentage}%)`;
              }
            }
          }
        }
      }
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const response = await this.axios.get('/api/stats/freelancers/experience');
        this.prepareChartData(response.data);
      } catch (error) {
        console.error('Error fetching experience distribution:', error);
      } finally {
        this.loading = false;
      }
    },
    prepareChartData(data) {
      const experiences = data.map(item => this.formatExperienceLabel(item.experience));
      const counts = data.map(item => item.total);
      const backgroundColors = this.generateColors(data.length);

      this.chartData = {
        labels: experiences,
        datasets: [
          {
            data: counts,
            backgroundColor: backgroundColors
          }
        ]
      };
    },
    formatExperienceLabel(experience) {
      const levels = {
        'beginner': 'Débutant',
        'intermediate': 'Intermédiaire',
        'advanced': 'Avancé',
        'expert': 'Expert'
      };
      
      return levels[experience] || experience;
    },
    generateColors(count) {
      const baseColors = [
        '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', 
        '#9966FF', '#FF9F40', '#8AC926', '#1982C4',
        '#6A4C93', '#F15BB5', '#00BBF9', '#00F5D4'
      ];
      
      return baseColors.slice(0, count);
    }
  }
}
</script>

<style scoped>
.card-body {
  min-height: 300px;
}
</style>